// disable scrolling on number fields. This is causing numbers to change while
// you're scrolling down the page
document.addEventListener('wheel', () => {
  if (document.activeElement.type === 'number') {
    document.activeElement.blur();
  }
});
